import Icon from 'components/ui/Icon';
import { FaqBlockModel } from 'types/block-types';

const FaqBlock = ({ title, items = [] }: FaqBlockModel): JSX.Element => {
	const schema = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: items.map((item) => ({
			'@type': 'Question',
			name: item.question,
			acceptedAnswer: {
				'@type': 'Answer',
				text: item.answer,
			},
		})),
	};

	return (
		<>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
			/>

			<section className="faq mx-auto max-w-site px-4 my-3 lg:my-10">
				{title && <h2 className="text-h2 text-center  mb-6">{title}</h2>}

				{items.map((item, index) => (
					<article>
						<details
							key={index}
							className="faq-item  group border-b border-greyDarker mb-3"
						>
							<summary className="flex items-center justify-between gap-4 py-3 cursor-pointer list-none">
								<h3 className="text-h3 ">{item.question}</h3>

								<span>
									<Icon icon="chevronDown" size={1} />
								</span>
							</summary>

							<p className="text-p pb-4">{item.answer}</p>
						</details>
					</article>
				))}
			</section>
		</>
	);
};

export default FaqBlock;
